module.exports = __webpack_public_path__ + "img/03_sub_uk.fe567af9.svg";